import { queryOptions } from '@tanstack/react-query';

import type {
  BookingEmailTemplateSettingsQueryParams,
  BookingEmailTemplateSettingsResponse,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const bookingEmailTemplateSettingKeys = {
  all: () => ['bookingEmailTemplateSettings'] as const,
  list: (props: BookingEmailTemplateSettingsQueryParams) =>
    [...bookingEmailTemplateSettingKeys.all(), 'list', props.url] as const,
};

export const bookingEmailTemplateSettingQueries = {
  list: (props: BookingEmailTemplateSettingsQueryParams) =>
    queryOptions({
      queryKey: bookingEmailTemplateSettingKeys.list(props),
      queryFn: () =>
        HttpClient.request<BookingEmailTemplateSettingsResponse>({
          method: 'GET',
          url: props.url,
        }),
      refetchOnWindowFocus: false,
    }),
};
